// packages/web-ui/src/components/inline-cards/raster-timeout.ts
//
// Single source of truth for the client-side raster-generation timeout backstop.
// A raster gen takes tens of seconds (~124s for `quality: high`, hence the
// default `medium`); if neither `image:genReady` nor `image:genFailed` ever
// lands (e.g. a silent server-side fallback-on-error) the UI must NEVER hang in
// an infinite spinner. Every surface that renders the raster lifecycle
// (`IllustrativeImagePanel`, `ViewRasterSurface`, `ViewImageModal`) shares this
// constant so the "taking longer than expected" backstop fires at the same
// point everywhere.
//
// Extracted to a leaf module so `ViewImageModal` can consume it WITHOUT the
// `ViewImageModal ↔ IllustrativeImagePanel` import cycle (the latter imports the
// former). `IllustrativeImagePanel` re-exports it, so its existing public
// `IMAGE_GEN_TIMEOUT_MS` export stays stable for current importers.
export const IMAGE_GEN_TIMEOUT_MS = 180_000;
